import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { AssetsService } from "app/services/AssetsService";

import { Content, Footer, GeneralButton, Header, Title } from "../common.styled";

import {
    EmailItem,
    EmailsContainer,
    EmailsList,
    EmailsListPrefix,
    EmailsListSuffix,
    HandsImage,
} from "./EmailSentScreen.styled";

const getAssetsUrl = AssetsService.assetUrl.bind(AssetsService);

interface IEmailSentScreenProps {
    onClose: () => void;
    emails: string[];
}

const EmailSentScreen: React.FC<IEmailSentScreenProps> = ({ onClose, emails }) => {
    const translate = useTranslation();

    return (
        <>
            <Header>
                <Title>{translate("growth.homepage.inviteUsersV2.modal.sent.title")}</Title>
            </Header>
            <Content secondScreen>
                <EmailsContainer>
                    <EmailsListPrefix>
                        {translate("growth.homepage.inviteUsersV2.modal.sent.emails_prefix")}
                    </EmailsListPrefix>
                    <EmailsList>
                        {emails.map((email) => (
                            <EmailItem key={email}>{`${email}, `}</EmailItem>
                        ))}
                    </EmailsList>

                    <EmailsListSuffix>
                        {translate("growth.homepage.inviteUsersV2.modal.sent.emails_suffix")}
                    </EmailsListSuffix>
                    <HandsImage
                        src={getAssetsUrl("/images/InviteUsersV2/clap_hands.svg")}
                        alt={translate("growth.homepage.inviteUsersV2.modal.sent.image_alt")}
                    />
                </EmailsContainer>
            </Content>

            <Footer>
                <GeneralButton
                    type="primary"
                    onClick={onClose}
                >
                    {translate("growth.homepage.inviteUsersV2.modal.sent.close")}
                </GeneralButton>
            </Footer>
        </>
    );
};

export default EmailSentScreen;
